import { useState, useEffect } from 'react';

var TransitionStatus;
(function(TransitionStatus) {
    TransitionStatus["ENTERED"] = 'entered';
    TransitionStatus["ENTERING"] = 'entering';
    TransitionStatus["EXITED"] = 'exited';
    TransitionStatus["EXITING"] = 'exiting';
})(TransitionStatus || (TransitionStatus = {}));
function useTransition(transitionIsOpen, duration = 200) {
    const [transitionState, setTransitionState] = useState(transitionIsOpen ? TransitionStatus.ENTERED : TransitionStatus.EXITED);
    useEffect(()=>{
        setTransitionState((currentState)=>{
            if (transitionIsOpen) {
                return currentState !== TransitionStatus.ENTERED ? TransitionStatus.ENTERING : TransitionStatus.ENTERED;
            }
            return currentState !== TransitionStatus.EXITED ? TransitionStatus.EXITING : TransitionStatus.EXITED;
        });
        const timer = setTimeout(()=>{
            setTransitionState((currentState)=>{
                switch(currentState){
                    case TransitionStatus.ENTERING:
                        return TransitionStatus.ENTERED;
                    case TransitionStatus.EXITING:
                        return TransitionStatus.EXITED;
                    default:
                        return currentState;
                }
            });
        }, duration);
        return ()=>clearTimeout(timer);
    }, [
        duration,
        transitionIsOpen
    ]);
    return transitionState;
}

export { TransitionStatus, useTransition };
